import './styles/clasesmuestra.css'

import { useEffect, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"

//Components
import Snack from "../components/snack"
import Menu from "../components/menu"
import Loader from '../components/loader'
import { ImCross } from "react-icons/im"
import Confirm from '../components/confirm'
import Academias from '../components/academias'

//Extras
import { fontType, main } from "../assets/extras"
import { getCurrentDate, compareDates, getCurrentDay } from "../assets/validator"
import { db } from "../assets/connections"
import { collection, doc, getDocs, query, updateDoc, where, setDoc, increment } from 'firebase/firestore'


const ClasesMuestra = () => {

    const navigate = useNavigate()
        
    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [ variables, setVariables ] = useState({
        loading: true,
        clasesUno: [],
        clasesDos: [],
        clasesTres: [],
        academias: [],
        showAcademies: false,
        classes: [],
        selector: false,
        selectedItem: null,
        selectedAcademy: null,
        selectedDate: null
    })

    const [ playerSearch, setPlayerSearch ] = useState("")

    //Varibles para el uso del confirm
    const [confirm, setConfirm] = useState({
        show: false,
        title: "",
        text: ""
    })

    //Variable que selecciona a un unico item de la lista
    const [ item, setItem ] = useState({
        id: "",
        lista: 0,
        index: 0,
        data: null
    })

    //Funcion que ordena el arreglo de clase de mas reciente a mas antigua
    function ordenarPorFechaDescendente(arr) {
        return arr.sort((a, b) => new Date(b.fecha_clase) - new Date(a.fecha_clase));
    }

    const getFecha = (fechaStr) => {
        const diasSemana = [
            "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
        ]
        const meses = [
            "enero", "febrero", "marzo", "abril", "mayo", "junio",
            "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
        ]

        // Asegura que la fecha tenga el formato yyyy-mm-dd con ceros
        const [anio, mes, dia] = fechaStr.split('-').map(n => parseInt(n, 10))
        const fecha = new Date(anio, mes - 1, dia) // Date(mesIndexadoDesdeCero)

        const diaSemana = diasSemana[fecha.getDay()]
        const mesNombre = meses[fecha.getMonth()]
        const mesCapitalizado = mesNombre.charAt(0).toUpperCase() + mesNombre.slice(1)

        return `${diaSemana} ${fecha.getDate()} de ${mesCapitalizado} del ${fecha.getFullYear()}`
    }

    //Funcion que formatea las fechas de las clases
    //Funcion que formatea el subitulo
    const formatSubtitle = (dias_clase) => {
        var dias = ""
        dias_clase.map(v => {
            var dia = ""
            
            // Validar que v.de y v.a existan antes de usar
            const horaInicio = (v.de && typeof v.de === 'string' && v.de.includes(":")) 
                ? v.de 
                : (v.de && v.de.length === 1 ? "0" + v.de : (v.de || ""))
            
            const horaFin = (v.a && typeof v.a === 'string' && v.a.includes(":")) 
                ? v.a 
                : (v.a && v.a.length === 1 ? "0" + v.a : (v.a || ""))
            
            var hora = horaInicio + "-" + horaFin
            
            // Validar que v.dia exista antes de acceder a sus caracteres
            if (v.dia) {
                for(let i = 0; i < 3 && i < v.dia.length; i++){
                    dia += v.dia[i]
                }
            }

            if(dias == ""){
                dias = dia + " " + hora
            } else {
                dias += " / " + dia + " " + hora
            }

        })

        return dias
    }

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que elimina la clase muestra
    const deleting = async () => {
        var data = item.data
        await setDoc(doc(db, "ClaseMuestra", item.id), {
            correo: data.correo,
            edad: data.edad,
            fecha_clase: "----/--/--",
            isReserved: false,
            nivel: data.nivel,
            nombre: data.nombre
        }).then(r => {
            if(item.lista === 1){
                variables.clasesUno.splice(item.index, 1)
                setItem(prev => (null))
                setVariables(prev => ({
                    ...prev
                }))

                showMessage("Clase borrada con exito", "success")
            } else if(item.lista === 2){
                variables.clasesDos.splice(item.index, 1)
                setItem(prev => (null))
                setVariables(prev => ({
                    ...prev
                }))

                showMessage("Clase borrada con exito", "success")
            } else if(item.lista === 3){
                variables.clasesTres.splice(item.index, 1)
                setItem(prev => (null))
                setVariables(prev => ({
                    ...prev
                }))

                showMessage("Clase borrada con exito", "success")
            }
        }).catch(e => {
            console.log(e)
            showMessage("Error al eliminar clase muestra", "error")
        })
    }

    //Funcion que elimina una clase muestra
    const onHandleDeleteClase = async (id, lista, index, data) => {
        setItem(prev => ({
            id: id,
            lista: lista,
            index: index,
            data: data
        }))
        setConfirm(prev => ({
            ...prev,
            title: "ELIMINAR CLASE MUESTRA",
            text: "¿Deseas eliminar la clase muestra?",
            show: true
        }))
    }

    //Funcion que actualiza la fecha de la clase muestra
    const changeAcademy = async (id, lista, index, data) => {
        if(variables.selectedDate){
            setVariables(prev => ({
                ...prev,
                selector: false,
                showAcademies: true,
                selectedItem: {
                    id: id,
                    lista: lista,
                    index: index,
                    data: data
                }
            }))
        } else {
            showMessage("Debes seleccionar una fecha para la clase", "warning")
        }
    }

    //Funcion que asiste al jugador
    const onHandleAsistio = async (id, lista, index, data) => {
        if(variables.selectedDate){
            await updateDoc(doc(db, "ClaseMuestra", id), {
                asistio: true,
                fecha_clase: variables.selectedDate.newDate,
                checked: true
            }).then(async r => {
                if(lista === 1){
                    if(!data.checked) {
                        await updateDoc(doc(doc(db, ref), "Clases", data.id_clase), {
                            clases_muestra: increment(-1)
                        }).then(r2 => {
    
                            variables.clasesUno.splice(index, 1)
                            variables.clasesDos.push({
                                ...data,
                                asistio: true,
                                fecha_clase: variables.selectedDate.newDate,
                                checked: true
                            })
                            setVariables(prev => ({
                                ...prev,
                                selectedDate: null,
                                selectedItem: null
                            }))
            
                            showMessage("Clase actualizada con exito", "success")
    
                        }).catch(e => {
                            console.log(e)
                            showMessage("Error al eliminar clase muestra", "error")
                        })
                    } else {
                        variables.clasesUno.splice(index, 1)
                        variables.clasesDos.push({
                            ...data,
                            asistio: true,
                            fecha_clase: variables.selectedDate.newDate,
                            checked: true
                        })
                        setVariables(prev => ({
                            ...prev,
                            selectedDate: null,
                            selectedItem: null
                        }))
        
                        showMessage("Clase actualizada con exito", "success")
                    }
                }
            }).catch(e => {
                console.log(e)
                showMessage("Error al eliminar clase muestra", "error")
            })
        } else {
            showMessage("Debes seleccionar una fecha de asistencia", "warning")
        }
    }

    //Funcion que quita la asistencia al jugador
    const onHandleNoAsistio = async (id, lista, index, data) => {
        await updateDoc(doc(db, "ClaseMuestra", id), {
            asistio: false,
            checked: true
        }).then(async r => {
            if(lista === 1){
                if(!data.checked){
                    await updateDoc(doc(doc(db, ref), "Clases", data.id_clase), {
                        clases_muestra: increment(-1)
                    }).then(r2 => {
                        variables.clasesUno[index] = {
                            ...data,
                            asistio: false
                        }
                        setVariables(prev => ({
                            ...prev,
                            selectedDate: null
                        }))
        
                        showMessage("Clase actualizada con exito", "success")
                    }).catch(e => {
                        console.log(e)
                        showMessage("Error al eliminar clase muestra", "error")
                    })
                } else {
                    variables.clasesUno[index] = {
                        ...data,
                        asistio: false
                    }
                    setVariables(prev => ({
                        ...prev,
                        selectedDate: null
                    }))
    
                    showMessage("Clase actualizada con exito", "success")
                }
                
            } else if(lista === 2){
                if(!data.checked){
                    await updateDoc(doc(doc(db, ref), "Clases", data.id_clase), {
                        clases_muestra: increment(-1)
                    }).then(async r2 => {
                        variables.clasesDos.splice(index, 1)
                        variables.clasesUno.push({
                            ...data,
                            asistio: false
                        })
                        setVariables(prev => ({
                            ...prev,
                            selectedDate: null
                        }))
    
                        showMessage("Clase actualizada con exito", "success")
                    }).catch(e => {
                        console.log(e)
                        showMessage("Error al eliminar clase muestra", "error")
                    })
                } else {
                    variables.clasesDos.splice(index, 1)
                    variables.clasesUno.push({
                        ...data,
                        asistio: false
                    })
                    setVariables(prev => ({
                        ...prev,
                        selectedDate: null
                    }))

                    showMessage("Clase actualizada con exito", "success")
                }
            }
        }).catch(e => {
            console.log(e)
            showMessage("Error al eliminar clase muestra", "error")
        })
    }

    //Funcion que obtiene todas las clases muestra
    const getData = async () => {
        await getDocs(query(collection(db, "ClaseMuestra"), where("academia", "==", academia))).then(async r => {
            var aux = []
            r.docs.map(v => {
                aux.push({
                    id: v.id,
                    dias: v.data().dias_clase.map(v => v.dia),
                    ...v.data()
                })
            })

            var uno = [], dos = [], tres = []
            aux.map(v => {
                let date = compareDates(getCurrentDate(), v.fecha_clase)
                if(v.isReserved === true && v.asistio === false && (date === 1 || date === 0)){
                    uno.push({
                        ...v
                    })
                } else {
                    if(v.isReserved === true && v.asistio === true){
                        dos.push({
                            ...v
                        })
                    } else {
                        if(v.isReserved === true, v.asistio === false && date === 2){
                            tres.push({
                                ...v
                            })
                        }
                    }
                }
            })

            await getDocs(query(collection(db, "Academias"))).then(a => {
                var ac = []
                a.docs.map(v => {
                    ac.push({
                        ...v.data(),
                        id: v.id,
                        path: v.ref.path
                    })
                })

                setVariables(prev => ({
                    ...prev,
                    clasesUno: ordenarPorFechaDescendente(uno),
                    clasesDos: ordenarPorFechaDescendente(dos),
                    clasesTres: ordenarPorFechaDescendente(tres),
                    academias: ac,
                    loading: false
                }))

            }).catch(e => {
                console.log(e)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Error al obtener las clases muestra", "error")
                }, 100)
            })

        }).catch(e => {
            console.log(e)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al obtener las clases muestra", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getData()
        }
    }, [])

    if(variables.loading)
    return (
        <Loader
            loading={variables.loading}
        />
    )

    return (
        <div className='mainClasesMuestra'>

                <Snack />

                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.title,
                    paddingBottom: 0
                }}>CLASES MUESTRA</h2>
                <h2 style={{
                    backgroundColor: main,
                    fontFamily: fontType.text,
                    marginTop: -50,
                    marginBottom: 40,
                    fontSize: 18,
                    padding: 10,
                    paddingBottom: 20,
                    paddingTop: 0
                }}>{
                    localStorage.getItem("authToken") ? 
                        JSON.parse(localStorage.getItem("authToken")).nombre_academia
                    : ""
                }</h2>

                <Menu
                    academia={academia}
                    reference={ref}
                />

                <Confirm
                    confirm={confirm}
                    setConfirm={setConfirm}
                    onHandle={() => {
                        setConfirm(prev => ({
                            ...prev,
                            show: false
                        }))
                        setTimeout(() => {
                            deleting()
                        }, 10)
                    }}
                />

                <Academias
                    setVariables={setVariables}
                    variables={variables}
                    showMessage={showMessage}
                />

                <div style={{
                    width: "95%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    flexDirection: "row",
                    marginBottom: 10
                }}>
                    <input
                        style={{
                            width: "80%",
                            height: 30,
                            borderColor: "#CCCCCC",
                            borderRadius: 5,
                            borderWidth: 2,
                            borderStyle: "solid",
                            textAlign: "center",
                            fontFamily: fontType.text,
                            color: "black",
                            outline: "none"
                        }}
                        placeholder='Buscar Jugador'
                        value={playerSearch}
                        onChange={e => {
                            setPlayerSearch(prev => (e.target.value))
                        }}
                    />
                    <button onClick={() => {
                        window.open("https://tenistapp2000.web.app/tenista/clasesmuestra", '_blank');
                    }} style={{
                        backgroundColor: main,
                        fontFamily: fontType.title,
                        color: "white",
                        border: "none",
                        borderRadius: 10,
                        padding: 10,
                        fontSize: 18,
                        cursor: "pointer"
                    }}>
                        AGENDAR CLASE
                    </button>
                </div>

                <div className='contClasesMuestra'>
                
                    <div className='clases'>
                        <h3 style={{
                            fontFamily: fontType.title,
                            marginBottom: 20
                        }}>AGENDADAS</h3>
                        
                        {
                            playerSearch === "" ?
                                variables.clasesUno.map((v, i) => {
                                    return (
                                        <div className='clase' style={{
                                            borderColor: compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                            "#EE0000" : "black"
                                        }}>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold",
                                                marginBottom: 5,
                                                fontSize: 15
                                            }}>{v.nombre}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13
                                            }}>{getFecha(v.fecha_clase)}</p>
                                            <div style={{
                                                padding: 10,
                                                border: "1px solid black",
                                                marginTop: 15,
                                                borderRadius: 10,
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                fontFamily: fontType.text,
                                                gap: 10,
                                                fontSize: 14
                                            }}>
                                                <p>{v.correo}</p>
                                                <p>{v.telefono ? v.telefono : "No hay telefono registrado"}</p>
                                            </div>

                                            <p style={{ marginTop: 10, fontFamily: fontType.text, fontSize: 14 }}><span
                                                style={{
                                                    fontWeight: "bold"
                                                }}
                                            >Estatus: </span> {
                                                v.checked != undefined ?
                                                    v.checked === false ?
                                                        compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                            "El profesor no marco asistencia"
                                                        :
                                                            "En proceso"
                                                    :
                                                        v.asistio === false ?
                                                            "No asistio"
                                                        :
                                                            "Asistio"
                                                :
                                                    null
                                            }</p>

                                            <p style={{
                                                width:"100%",
                                                textAlign: "center",
                                                marginTop: 10,
                                                fontFamily: fontType.title,
                                                color: "#EE0000"
                                            }}>{
                                                v.checked !== undefined ?
                                                    compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                        v.checked === false ?
                                                            "El profesor no marco asistencia"
                                                        : null
                                                    :
                                                        null
                                                : null
                                            }</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                marginTop: 15,
                                                fontWeight: "bold"
                                            }}>{v.nombre_profesor}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{v.nombre_clase}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{formatSubtitle(v.dias_clase)}</p>
                                            {v.nombre_sede ? (
                                                <p style={{
                                                    fontFamily: fontType.text,
                                                    fontSize: 12,
                                                    fontStyle: "italic",
                                                    color: "#555",
                                                    marginTop: 2
                                                }}>Sede: {v.nombre_sede}</p>
                                            ) : null}

                                            <ImCross color='#770000' size={10} style={{
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: 10,
                                                right: 10
                                            }} onClick={() => onHandleDeleteClase(v.id, 1, i, v)} />

                                            <div style={{
                                                width: "100%",
                                                marginTop: 10,
                                                borderTop: "1px solid black",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                paddingTop: 20
                                            }}>

                                                <p style={{
                                                    fontFamily: fontType.title
                                                }}>{variables.selectedDate ? variables.selectedDate.newDate : ""}</p>

                                                <input
                                                    type='date'
                                                    style={{
                                                        marginTop: 5,
                                                        marginBottom: 20
                                                    }}
                                                    onChange={async e => {
                                                        let date = new Date(e.target.value)
                                                        let day = getCurrentDay(date.getDay() + 1)

                                                        setVariables(prev => ({
                                                            ...prev,
                                                            selectedDate: {
                                                                newDate: e.target.value,
                                                                day
                                                            }
                                                        }))
                                                        
                                                    }}
                                                />
                                            </div>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: "black",
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => changeAcademy(v.id, 1, i, v)}>
                                                REAGENDAR
                                            </button>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: main,
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => onHandleAsistio(v.id, 1, i, v)}>
                                                ASISTIO
                                            </button>

                                            {
                                                compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                    null
                                                : 
                                                    <button style={{
                                                        marginTop: 10,
                                                        padding: 6,
                                                        backgroundColor: "#990000",
                                                        border: "none",
                                                        color: "white",
                                                        fontFamily: fontType.title,
                                                        fontSize: 15,
                                                        borderRadius: 5,
                                                        cursor: "pointer"
                                                    }} onClick={() => onHandleNoAsistio(v.id, 1, i, v)}>
                                                        NO ASISTIO
                                                    </button>
                                            }
                                            

                                        </div>
                                    )
                                })
                            :
                                variables.clasesUno.filter(v => v.nombre.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize().match(playerSearch.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize()))
                                .map((v, i) => {
                                    return (
                                        <div className='clase' style={{
                                            borderColor: compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                            "#EE0000" : "black"
                                        }}>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold",
                                                marginBottom: 5,
                                                fontSize: 15
                                            }}>{v.nombre}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13
                                            }}>{getFecha(v.fecha_clase)}</p>
                                            <div style={{
                                                padding: 10,
                                                border: "1px solid black",
                                                marginTop: 15,
                                                borderRadius: 10,
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                fontFamily: fontType.text,
                                                gap: 10,
                                                fontSize: 14
                                            }}>
                                                <p>{v.correo}</p>
                                                <p>{v.telefono ? v.telefono : "No hay telefono registrado"}</p>
                                            </div>

                                            <p style={{ marginTop: 10, fontFamily: fontType.text, fontSize: 14 }}><span
                                                style={{
                                                    fontWeight: "bold"
                                                }}
                                            >Estatus: </span> {
                                                v.checked != undefined ?
                                                    v.checked === false ?
                                                        compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                            "El profesor no marco asistencia"
                                                        :
                                                            "En proceso"
                                                    :
                                                        v.asistio === false ?
                                                            "No asistio"
                                                        :
                                                            "Asistio"
                                                :
                                                    null
                                            }</p>

                                            <p style={{
                                                width:"100%",
                                                textAlign: "center",
                                                marginTop: 10,
                                                fontFamily: fontType.title,
                                                color: "#EE0000"
                                            }}>{
                                                v.checked !== undefined ?
                                                    compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                        v.checked === false ?
                                                            "El profesor no marco asistencia"
                                                        : null
                                                    :
                                                        null
                                                : null
                                            }</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                marginTop: 15,
                                                fontWeight: "bold"
                                            }}>{v.nombre_profesor}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{v.nombre_clase}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{formatSubtitle(v.dias_clase)}</p>
                                            {v.nombre_sede ? (
                                                <p style={{
                                                    fontFamily: fontType.text,
                                                    fontSize: 12,
                                                    fontStyle: "italic",
                                                    color: "#555",
                                                    marginTop: 2
                                                }}>Sede: {v.nombre_sede}</p>
                                            ) : null}

                                            <ImCross color='#770000' size={10} style={{
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: 10,
                                                right: 10
                                            }} onClick={() => onHandleDeleteClase(v.id, 1, i, v)} />

                                            <div style={{
                                                width: "100%",
                                                marginTop: 10,
                                                borderTop: "1px solid black",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                paddingTop: 20
                                            }}>

                                                <p style={{
                                                    fontFamily: fontType.title
                                                }}>{variables.selectedDate ? variables.selectedDate.newDate : ""}</p>

                                                <input
                                                    type='date'
                                                    style={{
                                                        marginTop: 5,
                                                        marginBottom: 20
                                                    }}
                                                    onChange={async e => {
                                                        let date = new Date(e.target.value)
                                                        let day = getCurrentDay(date.getDay() + 1)

                                                        setVariables(prev => ({
                                                            ...prev,
                                                            selectedDate: {
                                                                newDate: e.target.value,
                                                                day
                                                            }
                                                        }))
                                                        
                                                    }}
                                                />
                                            </div>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: "black",
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => changeAcademy(v.id, 1, i, v)}>
                                                REAGENDAR
                                            </button>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: main,
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => onHandleAsistio(v.id, 1, i, v)}>
                                                ASISTIO
                                            </button>

                                            {
                                                compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                    null
                                                : 
                                                    <button style={{
                                                        marginTop: 10,
                                                        padding: 6,
                                                        backgroundColor: "#990000",
                                                        border: "none",
                                                        color: "white",
                                                        fontFamily: fontType.title,
                                                        fontSize: 15,
                                                        borderRadius: 5,
                                                        cursor: "pointer"
                                                    }} onClick={() => onHandleNoAsistio(v.id, 1, i, v)}>
                                                        NO ASISTIO
                                                    </button>
                                            }
                                            

                                        </div>
                                    )
                                })
                        }
                    </div>

                    <div className='clases'>
                        <h3 style={{
                            fontFamily: fontType.title,
                            marginBottom: 20
                        }}>NO ASISTIO</h3>
                        
                        {
                            playerSearch === "" ?
                                variables.clasesTres.map((v, i) => {
                                    return (
                                        <div className='clase' style={{
                                            borderColor: compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                            "#EE0000" : "black"
                                        }}>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold",
                                                marginBottom: 5,
                                                fontSize: 15
                                            }}>{v.nombre}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13
                                            }}>{getFecha(v.fecha_clase)}</p>
                                            <div style={{
                                                padding: 10,
                                                border: "1px solid black",
                                                marginTop: 15,
                                                borderRadius: 10,
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                fontFamily: fontType.text,
                                                gap: 10,
                                                fontSize: 14
                                            }}>
                                                <p>{v.correo}</p>
                                                <p>{v.telefono ? v.telefono : "No hay telefono registrado"}</p>
                                            </div>

                                            <p style={{ marginTop: 10, fontFamily: fontType.text, fontSize: 14 }}><span
                                                style={{
                                                    fontWeight: "bold"
                                                }}
                                            >Estatus: </span> {
                                                v.checked != undefined ?
                                                    v.checked === false ?
                                                        compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                            "El profesor no marco asistencia"
                                                        :
                                                            "En proceso"
                                                    :
                                                        v.asistio === false ?
                                                            "No asistio"
                                                        :
                                                            "Asistio"
                                                :
                                                    null
                                            }</p>

                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                marginTop: 15,
                                                fontWeight: "bold"
                                            }}>{v.nombre_profesor}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{v.nombre_clase}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{formatSubtitle(v.dias_clase)}</p>
                                            {v.nombre_sede ? (
                                                <p style={{
                                                    fontFamily: fontType.text,
                                                    fontSize: 12,
                                                    fontStyle: "italic",
                                                    color: "#555",
                                                    marginTop: 2
                                                }}>Sede: {v.nombre_sede}</p>
                                            ) : null}

                                            <ImCross color='#770000' size={10} style={{
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: 10,
                                                right: 10
                                            }} onClick={() => onHandleDeleteClase(v.id, 1, i, v)} />

                                            <div style={{
                                                width: "100%",
                                                marginTop: 10,
                                                borderTop: "1px solid black",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                paddingTop: 20
                                            }}>

                                                <p style={{
                                                    fontFamily: fontType.title
                                                }}>{variables.selectedDate ? variables.selectedDate.newDate : ""}</p>

                                                <input
                                                    type='date'
                                                    style={{
                                                        marginTop: 5,
                                                        marginBottom: 20
                                                    }}
                                                    onChange={async e => {
                                                        let date = new Date(e.target.value)
                                                        let day = getCurrentDay(date.getDay() + 1)

                                                        setVariables(prev => ({
                                                            ...prev,
                                                            selectedDate: {
                                                                newDate: e.target.value,
                                                                day
                                                            }
                                                        }))
                                                        
                                                    }}
                                                />
                                            </div>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: "black",
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => changeAcademy(v.id, 1, i, v)}>
                                                REAGENDAR
                                            </button>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: main,
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => onHandleAsistio(v.id, 1, i, v)}>
                                                ASISTIO
                                            </button>

                                            {
                                                compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                    null
                                                : 
                                                    <button style={{
                                                        marginTop: 10,
                                                        padding: 6,
                                                        backgroundColor: "#990000",
                                                        border: "none",
                                                        color: "white",
                                                        fontFamily: fontType.title,
                                                        fontSize: 15,
                                                        borderRadius: 5,
                                                        cursor: "pointer"
                                                    }} onClick={() => onHandleNoAsistio(v.id, 1, i, v)}>
                                                        NO ASISTIO
                                                    </button>
                                            }
                                            

                                        </div>
                                    )
                                })
                            :
                                variables.clasesTres.filter(v => v.nombre.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize().match(playerSearch.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize()))
                                .map((v, i) => {
                                    return (
                                        <div className='clase' style={{
                                            borderColor: compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                            "#EE0000" : "black"
                                        }}>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold",
                                                marginBottom: 5,
                                                fontSize: 15
                                            }}>{v.nombre}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13
                                            }}>{getFecha(v.fecha_clase)}</p>
                                            <div style={{
                                                padding: 10,
                                                border: "1px solid black",
                                                marginTop: 15,
                                                borderRadius: 10,
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                fontFamily: fontType.text,
                                                gap: 10,
                                                fontSize: 14
                                            }}>
                                                <p>{v.correo}</p>
                                                <p>{v.telefono ? v.telefono : "No hay telefono registrado"}</p>
                                            </div>

                                            <p style={{ marginTop: 10, fontFamily: fontType.text, fontSize: 14 }}><span
                                                style={{
                                                    fontWeight: "bold"
                                                }}
                                            >Estatus: </span> {
                                                v.checked != undefined ?
                                                    v.checked === false ?
                                                        compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                            "El profesor no marco asistencia"
                                                        :
                                                            "En proceso"
                                                    :
                                                        v.asistio === false ?
                                                            "No asistio"
                                                        :
                                                            "Asistio"
                                                :
                                                    null
                                            }</p>

                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                marginTop: 15,
                                                fontWeight: "bold"
                                            }}>{v.nombre_profesor}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{v.nombre_clase}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{formatSubtitle(v.dias_clase)}</p>
                                            {v.nombre_sede ? (
                                                <p style={{
                                                    fontFamily: fontType.text,
                                                    fontSize: 12,
                                                    fontStyle: "italic",
                                                    color: "#555",
                                                    marginTop: 2
                                                }}>Sede: {v.nombre_sede}</p>
                                            ) : null}

                                            <ImCross color='#770000' size={10} style={{
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: 10,
                                                right: 10
                                            }} onClick={() => onHandleDeleteClase(v.id, 1, i, v)} />

                                            <div style={{
                                                width: "100%",
                                                marginTop: 10,
                                                borderTop: "1px solid black",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                paddingTop: 20
                                            }}>

                                                <p style={{
                                                    fontFamily: fontType.title
                                                }}>{variables.selectedDate ? variables.selectedDate.newDate : ""}</p>

                                                <input
                                                    type='date'
                                                    style={{
                                                        marginTop: 5,
                                                        marginBottom: 20
                                                    }}
                                                    onChange={async e => {
                                                        let date = new Date(e.target.value)
                                                        let day = getCurrentDay(date.getDay() + 1)

                                                        setVariables(prev => ({
                                                            ...prev,
                                                            selectedDate: {
                                                                newDate: e.target.value,
                                                                day
                                                            }
                                                        }))
                                                        
                                                    }}
                                                />
                                            </div>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: "black",
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => changeAcademy(v.id, 1, i, v)}>
                                                REAGENDAR
                                            </button>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: main,
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => onHandleAsistio(v.id, 1, i, v)}>
                                                ASISTIO
                                            </button>

                                            {
                                                compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                    null
                                                : 
                                                    <button style={{
                                                        marginTop: 10,
                                                        padding: 6,
                                                        backgroundColor: "#990000",
                                                        border: "none",
                                                        color: "white",
                                                        fontFamily: fontType.title,
                                                        fontSize: 15,
                                                        borderRadius: 5,
                                                        cursor: "pointer"
                                                    }} onClick={() => onHandleNoAsistio(v.id, 1, i, v)}>
                                                        NO ASISTIO
                                                    </button>
                                            }
                                            

                                        </div>
                                    )
                                })
                        }
                    </div>

                    <div className='clases'>
                        <h3 style={{
                            fontFamily: fontType.title,
                            marginBottom: 20
                        }}>ASISTIO</h3>

                        {
                            playerSearch === "" ?
                                variables.clasesDos.map((v, i) => {
                                    return (
                                        <div className='clase'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold",
                                                marginBottom: 5,
                                                fontSize: 15
                                            }}>{v.nombre}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13
                                            }}>{getFecha(v.fecha_clase)}</p>
                                            <div style={{
                                                padding: 10,
                                                border: "1px solid black",
                                                marginTop: 15,
                                                borderRadius: 10,
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                fontFamily: fontType.text,
                                                gap: 10,
                                                fontSize: 14
                                            }}>
                                                <p>{v.correo}</p>
                                                <p>{v.telefono ? v.telefono : "No hay telefono registrado"}</p>
                                            </div>

                                            <p style={{ marginTop: 10, fontFamily: fontType.text, fontSize: 14 }}><span
                                                style={{
                                                    fontWeight: "bold"
                                                }}
                                            >Estatus: </span> {
                                                v.checked != undefined ?
                                                    v.checked === false ?
                                                        compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                            "El profesor no marco asistencia"
                                                        :
                                                            "En proceso"
                                                    :
                                                        v.asistio === false ?
                                                            "No asistio"
                                                        :
                                                            "Asistio"
                                                :
                                                    null
                                            }</p>

                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                marginTop: 15,
                                                fontWeight: "bold"
                                            }}>{v.nombre_profesor}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{v.nombre_clase}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{formatSubtitle(v.dias_clase)}</p>
                                            {v.nombre_sede ? (
                                                <p style={{
                                                    fontFamily: fontType.text,
                                                    fontSize: 12,
                                                    fontStyle: "italic",
                                                    color: "#555",
                                                    marginTop: 2
                                                }}>Sede: {v.nombre_sede}</p>
                                            ) : null}

                                            <Link style={{
                                                marginTop: 20,
                                                padding: 6,
                                                backgroundColor: main,
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer",
                                                textDecoration: "none"
                                            }} to={"/controlpanel/clasesmuestra/registro"} state={{
                                                ref: ref,
                                                correo: v.correo,
                                                edad: v.edad,
                                                nivel: v.nivel,
                                                nombre: v.nombre,
                                                telefono: v.telefono ? v.telefono : null,
                                                clase: v.id_clase,
                                                id: v.id,
                                                academia: academia
                                            }} replace={true}>
                                                INSCRIBIR
                                            </Link>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: "#990000",
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => onHandleNoAsistio(v.id, 2, i, v)}>
                                                NO ASISTIO
                                            </button>

                                            <ImCross color='#770000' size={10} style={{
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: 10,
                                                right: 10
                                            }} onClick={() => onHandleDeleteClase(v.id, 2, i, v)} />
                                        
                                        </div>
                                    )
                                })
                            :
                                variables.clasesDos.filter(v => v.nombre.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize().match(playerSearch.toLowerCase().trim().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, "$1").normalize()))
                                .map((v, i) => {
                                    return (
                                        <div className='clase'>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontWeight: "bold",
                                                marginBottom: 5,
                                                fontSize: 15
                                            }}>{v.nombre}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13
                                            }}>{getFecha(v.fecha_clase)}</p>
                                            <div style={{
                                                padding: 10,
                                                border: "1px solid black",
                                                marginTop: 15,
                                                borderRadius: 10,
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                flexDirection: "column",
                                                fontFamily: fontType.text,
                                                gap: 10,
                                                fontSize: 14
                                            }}>
                                                <p>{v.correo}</p>
                                                <p>{v.telefono ? v.telefono : "No hay telefono registrado"}</p>
                                            </div>

                                            <p style={{ marginTop: 10, fontFamily: fontType.text, fontSize: 14 }}><span
                                                style={{
                                                    fontWeight: "bold"
                                                }}
                                            >Estatus: </span> {
                                                v.checked != undefined ?
                                                    v.checked === false ?
                                                        compareDates(getCurrentDate(), v.fecha_clase) === 2 ?
                                                            "El profesor no marco asistencia"
                                                        :
                                                            "En proceso"
                                                    :
                                                        v.asistio === false ?
                                                            "No asistio"
                                                        :
                                                            "Asistio"
                                                :
                                                    null
                                            }</p>

                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                marginTop: 15,
                                                fontWeight: "bold"
                                            }}>{v.nombre_profesor}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{v.nombre_clase}</p>
                                            <p style={{
                                                fontFamily: fontType.text,
                                                fontSize: 13,
                                                fontWeight: "bold"
                                            }}>{formatSubtitle(v.dias_clase)}</p>
                                            {v.nombre_sede ? (
                                                <p style={{
                                                    fontFamily: fontType.text,
                                                    fontSize: 12,
                                                    fontStyle: "italic",
                                                    color: "#555",
                                                    marginTop: 2
                                                }}>Sede: {v.nombre_sede}</p>
                                            ) : null}

                                            <Link style={{
                                                marginTop: 20,
                                                padding: 6,
                                                backgroundColor: main,
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer",
                                                textDecoration: "none"
                                            }} to={"/controlpanel/clasesmuestra/registro"} state={{
                                                ref: ref,
                                                correo: v.correo,
                                                edad: v.edad,
                                                nivel: v.nivel,
                                                nombre: v.nombre,
                                                telefono: v.telefono ? v.telefono : null,
                                                clase: v.id_clase,
                                                id: v.id,
                                                academia: academia
                                            }} replace={true}>
                                                INSCRIBIR
                                            </Link>

                                            <button style={{
                                                marginTop: 10,
                                                padding: 6,
                                                backgroundColor: "#990000",
                                                border: "none",
                                                color: "white",
                                                fontFamily: fontType.title,
                                                fontSize: 15,
                                                borderRadius: 5,
                                                cursor: "pointer"
                                            }} onClick={() => onHandleNoAsistio(v.id, 2, i, v)}>
                                                NO ASISTIO
                                            </button>

                                            <ImCross color='#770000' size={10} style={{
                                                cursor: "pointer",
                                                position: "absolute",
                                                top: 10,
                                                right: 10
                                            }} onClick={() => onHandleDeleteClase(v.id, 2, i, v)} />
                                        
                                        </div>
                                    )
                                })
                        }
                    </div>
                    
                </div>

            </div>
    )
}

export default ClasesMuestra